<template>
  <div class="d-flex gap-2 align-items-center">
    <i
      :id="`${id}-tooltip`"
      class="float-end input-tooltip-btn"
      :class="[
        iconClass,
        variantClass,
      ]"
      @mouseenter="isHover = true"
      @mouseleave="isHover = false"
    />
    <b-tooltip :target="`${id}-tooltip`" triggers="hover" :placement="placement">
      {{ tooltip }}
    </b-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    id: { type: String, default: '' },
    tooltip: { type: String, default: '' },
    placement: { type: String, default: 'right' },
    variant: {
      type: String,
      default: 'standard',
      validator: (v) => ['standard', 'success', 'warning', 'danger'].includes(v),
    },
    iconType: {
      type: String,
      default: 'outline',
      validator: (v) => ['outline', 'fill'].includes(v),
    },
  },
  data() {
    return { isHover: false }
  },
  computed: {
    iconClass() {
      return this.iconType === 'fill' ? 'icon-fill_info' : 'icon-outline_info'
    },
    variantClass() {
      return `tooltip-variant-${this.variant}`
    },
  },
}
</script>

<style lang="scss" scoped>
.input-tooltip-btn.icon-outline_info::before,
.input-tooltip-btn.icon-fill_info::before {
  color: $teal-400;
}

.input-tooltip-btn.icon-outline_info.tooltip-variant-success::before,
.input-tooltip-btn.icon-fill_info.tooltip-variant-success::before {
  color: $green;
}

.input-tooltip-btn.icon-outline_info.tooltip-variant-warning::before,
.input-tooltip-btn.icon-fill_info.tooltip-variant-warning::before {
  color: $yellow;
}

.input-tooltip-btn.icon-outline_info.tooltip-variant-danger::before,
.input-tooltip-btn.icon-fill_info.tooltip-variant-danger::before {
  color: $red;
}
</style>
